export default "__VITE_ASSET__DCtR6yuI__"